export const renderImageFooter = (ref) => {
  const images = ref?.getElementsByTagName('img');
  if (!images) return;
  const route = useRoute();

  for (const image of images) {
    const url = new URL(image.src);
    url.protocol = 'https:';
    url.port = '';
    url.host = 'histrf.ru';
    image.src = url.href;
    const dataDescription = image.dataset.description;
    const dataSource = image.dataset.source;
    const wrapper = document.createElement('div');
    const imageWrapper = document.createElement('div');
    const component = image.closest('[data-type="img"]');
    component.innerHTML = '';
    component.append(wrapper);
    wrapper.append(imageWrapper);
    imageWrapper.append(image);
    image.style.margin = '0 auto';

    if (
      route.path.startsWith('/teacher') &&
      document.location.host === url.host
    ) {
      const download = document.createElement('a');
      wrapper.classList.add('image-card__wrapper');
      imageWrapper.classList.add('image-card__image-wrapper');
      download.classList.add('image-card__download');
      download.href = image.src;
      download.setAttribute(
        'download',
        image.src.split('/').at(-1).split('.')[0] ?? 'image',
      );
      imageWrapper.append(download);
    }

    const footer = document.createElement('div');
    footer.classList.add('image-card__footer');
    wrapper.append(footer);

    if (dataDescription || dataSource) {
      const description = document.createElement('span');
      description.classList.add('text-smaller');
      description.style.fontWeight = 'bold';
      footer.append(description);

      if (dataDescription) description.append(dataDescription);

      const source = document.createElement('span');
      source.classList.add('text-smaller');
      footer.append(source);

      if (dataSource) {
        source.append(`Источник: ${dataSource}`);
      }
    }
  }

  // for (const image of images) {
  //   const url = new URL(image.src);
  //   url.port = '';
  //   url.host = 'histrf.ru';
  //   image.src = url.href;
  //   const dataDescription = image.dataset.description;
  //   const dataSource = image.dataset.source;

  //   if (dataDescription || dataSource) {
  //     const wrapper = document.createElement('div');
  //     wrapper.classList.add('image-card__wrapper');

  //     image.parentElement.append(wrapper);
  //     wrapper.append(image);

  //     const footer = document.createElement('div');
  //     footer.classList.add('image-card__footer');
  //     wrapper.append(footer);

  //     const description = document.createElement('span');
  //     description.classList.add('text-smaller');
  //     description.style.fontWeight = 'bold';
  //     footer.append(description);

  //     if (dataDescription) description.append(dataDescription);

  //     const source = document.createElement('span');
  //     source.classList.add('text-smaller');
  //     footer.append(source);

  //     if (dataSource) {
  //       source.append(`Источник: ${dataSource}`);
  //     }
  //   }
  // }
};
